export const CHART_TYPE = "chartType";
export const COLUMN_ORDER_KEY = "columnOrder";
export const COLUMN_TITLE = "columnTitle";
export const COLUMN_WIDTH_KEY = "columnWidth";
export const CONTROLS = "controls";
export const HIDDEN_CATEGORIES = "hiddenCategories";
export const HIDDEN_SERIES = "hiddenSeries";
export const INCLUDE_NODES = "includeNodes";
export const PATH_VALUE = "pathValue";
export const SHOW_PERCENTAGES = "showPercentages";
export const SORT_ORDER_KEY = "sortOrder";
export const TABLE_COLUMN_TOGGLES = "tableColumnsToggles";
export const TOOLTIPS = "tooltips";
export const VISIBLE_DATASETS = "visibleDatasets";
